'use strict';

import remainScrollAfterCtaAction from '../remainScrollAfterCtaAction';

var addProductToCart = require('./product/addToCart'),
    page = require('../page'),
    login = require('../login'),
    util = require('../util');

remainScrollAfterCtaAction($('button.delete-item'));

exports.init = function () {
    addProductToCart();
    $('#editAddress').on('change', function () {
        page.redirect(util.appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val()));
    });

    //add js logic to remove the , from the qty feild to pass regex expression on client side
    $('.option-quantity-desired input').on('focusout', function () {
        $(this).val($(this).val().replace(',', ''));
    });

    login.init();

};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/wishlist.js